/* eslint semi:0 */
import { TYPES } from '../actions/googleSearchActions'
import { BaseStore } from './baseStore'
import { external } from '../../utils/script'

let googleSearch = external.load({ name: 'googleSearch' })

class GoogleSearchStore extends BaseStore {
  routeAction(action) {
    let ACTIONS = TYPES
    switch (action.type) {
      case ACTIONS.READY:
        return this.onGoogleSearchReady()
      case ACTIONS.SEARCH_CLICKED:
        return this.searchClicked(action.searchTerm)
    }
  }

  get searchTerm() {
    return this.state.searchTerm
  }
  set searchTerm(newTerm) {
    this.state.searchTerm = newTerm
  }

  get isGoogleSearchReady() {
    return this.state.googleSearchReady
  }
  set isGoogleSearchReady(bool) {
    this.state.googleSearchReady = bool
  }

  get isExpandedView() {
    return this.state.expandedView
  }
  set isExpandedView(bool) {
    this.state.expandedView = bool
  }

  onGoogleSearchReady() {
    this.isGoogleSearchReady = true
    if (this.searchTerm) {
      this.performSearch(this.searchTerm)
    }
  }

  searchClicked(searchTerm) {
    this.searchTerm = searchTerm
    if (this.isExpandedView) {
      if (this.searchTerm) {
        if (this.isGoogleSearchReady) {
          this.performSearch()
        }
      } else {
        this.isExpandedView = false
        this.emitChange()
      }
    } else {
      googleSearch() //causes SDK to load if it haven't already
      this.isExpandedView = true
      this.emitChange()
    }
  }

  performSearch() {
    googleSearch(() => {
      let element = window.google.search.cse.element.getElement('searchresults-only0') //documentation: https://developers.google.com/custom-search/docs/element#cse-element
      element.execute(this.searchTerm)
    })
  }
}

export default GoogleSearchStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/googleSearchStore.js